module.exports = __webpack_public_path__ + "img/img1.3dab93c3.jpg";